export const isDescriptionAdded = (description: any) => {
  if (!description) return false;

  if (description?.blocks) {
    return description.blocks.map((block: any) => block.text).join().length > 0;
  } else {
    return description.length > 0;
  }
};
